// Simple analytics helper: prefers gtag (Google Analytics), then firebase analytics (if available on window), otherwise falls back to console.
export function logEvent(eventName, params = {}) {
    try {
        if (typeof window !== 'undefined') {
            // gtag (Google Analytics)
            if (typeof window.gtag === 'function') {
                window.gtag('event', eventName, params);
                return;
            }

            // Firebase legacy analytics on window.firebase (if initialized elsewhere)
            if (window.firebase && typeof window.firebase.analytics === 'function') {
                try {
                    window.firebase.analytics().logEvent(eventName, params);
                    return;
                } catch (e) {
                    // ignore and fallback
                }
            }

            // If an initializer exposed a firebase log wrapper on window, use it
            if (typeof window.firebaseLogEvent === 'function') {
                try {
                    window.firebaseLogEvent(eventName, params);
                    return;
                } catch (e) {
                    // ignore
                }
            }
        }
    } catch (err) {
        // swallow errors and fallback to console
    }

    // Final fallback: log to console for debugging
    // You can replace this with a server-side endpoint if desired.
    // Keep logs lightweight to avoid exposing PII.
    // eslint-disable-next-line no-console
    console.debug('[analytics] event:', eventName, params);
}
